import { createGlobalStyle } from 'styled-components';
import { darken } from 'polished';

import Regular from './fonts/Poppins-Regular.ttf';
import Bold from './fonts/Poppins-Bold.ttf';
import SemiBold from './fonts/Poppins-SemiBold.ttf';

const GlobalStyle = createGlobalStyle`
    @font-face {
    font-family: 'Regular';
    src: local('Poppins-Regular'), url(${Regular}) format('truetype');
    }

    @font-face {
    font-family: 'Bold';
    src: local('Poppins-Bold'), url(${Bold}) format('truetype');
    }

    @font-face {
    font-family: 'SemiBold';
    src: local('Poppins-SemiBold'), url(${SemiBold}) format('truetype');
    }

    html {
        height: 100vh;
        width: 100vw;
        overflow-x: hidden;
        overflow-y: auto;
        touch-action: pan-y;
        font-family: Regular;
    }

    body {
        height: 100vh;
        width: 100vw;
        overflow-x: hidden;
        overflow-y: auto;
        touch-action: pan-y;
        margin: 0;
        font-family: Regular;
        background-color: ${({ theme }) => (theme.colors.primary)};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
    }

    #root {
        height: 100%;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        touch-action: pan-y;
    }

    p {
        user-select: none;
        pointer-events: none;
        margin: 0;
    }

    img {
        user-select: none;
        pointer-events: none;
    }

    //Scrollbar
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
    
    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 3px ${({ theme }) => (theme.colors.border)};
        border: 0.5px solid ${({ theme }) => (theme.colors.border)};
        background-color: ${({ theme }) => (theme.colors.secondary)};
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 2px ${({ theme }) => (theme.colors.border)};
        background: ${({ theme }) => (theme.colors.accent)};
    }
    
    ::-webkit-scrollbar-button {
        display: none;
    }
    
    ::-webkit-scrollbar-thumb:hover {
        background: ${({ theme }) => (darken(0.10, theme.colors.accent))};
    }

    ::-webkit-scrollbar-thumb:active {
        background: ${({ theme }) => (darken(0.20, theme.colors.accent))};
    }
`

export default GlobalStyle